import { jsx as _jsx } from "react/jsx-runtime";
const ComboboxEmpty = ({ children }) => {
    return (_jsx("li", { className: "skyline-text-body-1 flex min-h-[56px] w-full items-center px-4 py-[0.625rem] text-black first:rounded-t-lg last:rounded-b-lg focus:outline-none", children: children }));
};
export default ComboboxEmpty;
//# sourceMappingURL=ComboboxEmpty.js.map